import { TimelineRecord } from '../../types/invoiceTimeline'

/**
 * SC-10890: o que faz sentido reenviar agora.
 *
 * Só o envio MAIS RECENTE de cada canal. Numa cobrança com régua completa há
 * sete envios, mas reenviar a "Fatura em atraso D3" de julho não faz sentido
 * depois que o cliente recebeu D9, D18 e D30 — o histórico antigo é leitura, não
 * ação.
 *
 * `records` chega em ordem crescente, então o último de cada canal é o que vale.
 */
export const latestResendableByMedium = (
  records: TimelineRecord[]
): TimelineRecord[] => {
  const byMedium = new Map<string, TimelineRecord>()

  records
    .filter((record) => record.kind === 'notification' && record.resendable)
    .forEach((record) => {
      byMedium.set(record.medium || 'outro', record)
    })

  return Array.from(byMedium.values())
}

/**
 * Um envio está agendado quando o STATUS diz isso — não quando `scheduled_for`
 * está preenchido.
 *
 * `scheduled_for` guarda o horário em que o envio *estava* agendado e continua
 * gravado depois que ele sai: no payload real, um tracking com
 * `status: "Enviado"` e `date_sent` preenchido também traz `scheduled_for`.
 * Decidir pela presença do campo fazia uma notificação já enviada aparecer como
 * "Enviar agora" e o diálogo dizer que estava agendada.
 */
export const isScheduled = (record: TimelineRecord): boolean =>
  record.status === 'Envio agendado' || record.status === 'scheduled'

/** Rótulo da ação, na voz de quem cobra. */
export const resendLabelFor = (record: TimelineRecord): string => {
  if (isScheduled(record)) {
    return `Enviar agora por ${record.medium || 'este canal'}`
  }

  if (record.medium === 'WhatsApp') return 'Reenviar por WhatsApp'
  if (record.medium === 'E-mail') return 'Reenviar por e-mail'
  if (record.medium === 'SMS') return 'Reenviar por SMS'
  return 'Reenviar notificação'
}
